import {useMutation} from 'react-query'

import {mutations} from '../../mutations'
import {hubQueryClient} from '../../QueryProvider'

/**
 * Hook to dismiss a failed order change request banner.
 *
 * This mutation stores the dismissed requestId in distributeduserstorage,
 * so the banner won't show again for the same requestId.
 */
export const useDismissFailedOrderChangeRequest = () => {
  return useMutation(mutations.dismissFailedOrderChangeRequest, {
    onSuccess: () => {
      // Invalidate the dismissed requests query to update UI
      void hubQueryClient.invalidateQueries('dismissedFailedOrderChangeRequests')
    }
  })
}
